import './loader.css'

export const BtnLoader=()=> {
    return (
      <div className="loader"></div>
    )
  }